// extracted by mini-css-extract-plugin
module.exports = {"newsListingWrapper":"_1ADQ5","h1tag":"UvAgJ","miniTvtopband":"N_VpH","heading_fuelWidget":"tkne4","banner_spacing":"JSvcm","landingscorecard":"Di1kG"};